import type { Context } from '@vue-storefront/core';

export const getCt = (context: Context, { vsfCt = false }: { vsfCt?: boolean }) => {
  return vsfCt ? context.$vsf?.$ct : context.$integrations?.$ct;
};
